export interface ZapListOptions {
  limit?: string;
  sort_by?: string;
  sort_order?: string;
  search?: string;
}

export const ZapService = {
  async listZaps(apiOrigin: string, jwt: string, options: ZapListOptions = {}) {
    // Build query parameters
    const queryParams = new URLSearchParams({
      limit: options.limit || "10",
      sort_by: options.sort_by || "updated_at",
      sort_order: options.sort_order || "desc",
    });

    if (options.search) {
      queryParams.set("search", options.search);
    }

    const apiUrl = `${apiOrigin}/api/v4/zaps/?${queryParams.toString()}`;

    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `JWT ${jwt}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cache: "no-cache",
    });

    const data = await response.json();

    if (!response.ok) {
      console.error(
        `Error from Zapier API (${response.status}) for URL ${apiUrl}:`,
        data,
      );
      throw new Error(data?.error || `Zapier API error (${response.status})`);
    }

    return data;
  },

  // Add other Zap operations here as needed
};
